module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-sm table-bordered table-striped table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.rowsMemberCollections.data), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [(row.member_loan_plan) ? _c('span', [_vm._v(_vm._s(row.member_loan_plan.applicationNo))]) : _vm._e()]), _vm._v(" "), _c('td', [(row.member) ? _c('span', [_vm._v(_vm._s(row.member.name))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.paymentDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.amt) + " "), (row.type === 'panulty') ? _c('small', [_vm._v("(penalty)")]) : _c('small', [_vm._v("(" + _vm._s(row.type) + ")")])]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.received_by) ? _c('span', [_vm._v(_vm._s(row.received_by.name))]) : _vm._e()])])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Recent Paid EMIs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Sr. No.")]), _vm._v(" "), _c('th', [_vm._v("Loan ID")]), _vm._v(" "), _c('th', [_vm._v("Cust Name")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pay Date")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Received")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5660d132!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dashboard/recentcollection.vue
// module id = 809
// module chunks = 0